/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: any) {
    return {
        canAdmin: true,
    }
}
